import React from 'react';
import { Typography } from 'antd';
import type { ClientPaymentTerms } from 'api/swagger';
import styles from './client-financial-tag.module.scss';

interface IClientFinancialTagProps {
  paymentTerms?: ClientPaymentTerms | null;
  paymentPeriod?: number | null;
  clientPaymentTerms: ClientPaymentTerms;
  clientPaymentPeriod: number;
}

export const ClientFinancialTag: React.FC<IClientFinancialTagProps> = (props) => {
  const { paymentTerms, paymentPeriod, clientPaymentTerms, clientPaymentPeriod } = props;

  const customPaymentInfoExists = paymentTerms && paymentPeriod;

  const isModified =
    customPaymentInfoExists && (paymentTerms !== clientPaymentTerms || paymentPeriod !== clientPaymentPeriod);

  const paymentTermsFinal = customPaymentInfoExists ? paymentTerms : clientPaymentTerms;
  const paymentPeriodFinal = customPaymentInfoExists ? paymentPeriod : clientPaymentPeriod;

  return (
    <Typography.Text className={paymentTermsFinal === 'original' ? styles.byOriginal : undefined}>
      By {paymentTermsFinal}: {paymentPeriodFinal}d {isModified && <span className={styles.modified}>updated</span>}
    </Typography.Text>
  );
};
